export enum HIRING_PROCESS_STATUSES {
  ACTIVE = 'active',
  DISPOSITIONED = 'dispositioned',
  WITHDRAWN = 'withdrawn',
  HIRED = 'hired',
  OFFER_DECLINED = 'offer-declined',
}
